import { render, staticRenderFns } from "./InputFiles.component.vue?vue&type=template&id=7bb20f34"
import script from "./InputFiles.component.vue?vue&type=script&lang=js"
export * from "./InputFiles.component.vue?vue&type=script&lang=js"
import style0 from "./InputFiles.component.vue?vue&type=style&index=0&id=7bb20f34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports